<div class="row date">
  @if (training?.startDate) {
    {{ $safeNavigationMigration(training?.startDate) | date }}
  }
  @if (training?.endDate) {
    - {{ $safeNavigationMigration(training?.endDate) | date }}
  }
</div>
<div class="row customer">Company: {{ training?.customer?.name }}</div>
<div class="row reservation-group">
  <div class="header">
    <div class="reservation-info"><i class="icon icon-grid_view"></i>Reservation(s)</div>
    <div>
      Trainee: {{ training?.client?.firstName }} {{ training?.client?.middleName }}
      {{ training?.client?.lastName }}
    </div>
  </div>
  <div class="splitter"></div>
</div>
<div class="row reservations">
  <ul class="row list">
    @for (reservation of reservations; track reservation) {
      <li class="reservation">
        {{ reservation.geminiReservationId }} - {{ reservation?.training?.name }}
      </li>
    }
  </ul>
</div>
